import { render, staticRenderFns } from "./JeecgDemoModal.vue?vue&type=template&id=6966361a&scoped=true&"
import script from "./JeecgDemoModal.vue?vue&type=script&lang=js&"
export * from "./JeecgDemoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6966361a",
  null
  
)

export default component.exports